// extracted by css-extract-rspack-plugin
export default {"container":"RtF_wWQPLMrRNSHG","loading":"ZWX0p92VoQNefgcs","preloaderWrapper":"LguOcVkKlEw9tEcH","table":"YaJ5x8dHbKMHYjqQ","tdContainer":"xJOoCj_fDMovPesL"};